import { combineEpics } from "redux-observable";
import "./endpoints/index.js";
import { gatesEpic } from "./endpoints/gates.js";
import { gateTypesEpic } from "./endpoints/gate-types.js";
import { progressionTemplatesEpic } from "./endpoints/progression-templates.js";
import { progressionsEpic } from "./endpoints/progressions.js";
import { experimentOperationSetsEpic } from "./endpoints/experiment-operation-sets.js";
import { featuresEpic } from "./endpoints/features.js";
import { experimentsEpic } from "./endpoints/experiments.js";
import { audienceFiltersEpic as epic } from "./endpoints/audience-filters.js";
import { assignmentUnitsEpic as epic$1 } from "./endpoints/assignment-units.js";
import { isolationGroupsEpic as epic$2 } from "./endpoints/isolation-groups.js";
import { experimentationGroupSettingsEpic } from "./endpoints/experimentation-group-settings.js";
import { experimentationGroupsEpic } from "./endpoints/experimentation-groups.js";
import { variantsEpic } from "./endpoints/variants.js";
const unifiedRootEpic = combineEpics(
  gatesEpic,
  gateTypesEpic,
  progressionTemplatesEpic,
  progressionsEpic,
  experimentOperationSetsEpic,
  featuresEpic,
  experimentsEpic,
  epic,
  epic$1,
  epic$2,
  experimentationGroupSettingsEpic,
  experimentationGroupsEpic,
  variantsEpic
);
export {
  unifiedRootEpic as default,
  unifiedRootEpic
};
//# sourceMappingURL=epics.js.map
